import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router';
import { useMe } from '../../hooks/useMe';
import { Logo } from './Logo';
import { SkipLink } from './SkipLink';
import { UserMenu } from './UserMenu';

/** Simple layout for pages outside a workspace (auth, onboarding, account, admin, errors). */
export function PlainLayout({ children, width = 'md' }: { children: ReactNode; width?: 'sm' | 'md' | 'lg' }) {
  const me = useMe();
  const signedIn = Boolean(me.data);
  const max = width === 'sm' ? 'max-w-xl' : width === 'lg' ? 'max-w-5xl' : 'max-w-3xl';
  return (
    <div className="flex min-h-dvh flex-col">
      <SkipLink />
      <header className="border-b border-border bg-surface">
        <div className={`mx-auto flex min-h-16 w-full items-center justify-between gap-3 px-4 ${max}`}>
          <RouterLink to="/" className="no-underline" aria-label="Seventide home">
            <Logo />
          </RouterLink>
          {signedIn && <UserMenu />}
        </div>
      </header>
      <main id="main-content" tabIndex={-1} className={`mx-auto w-full flex-1 px-4 py-8 outline-none ${max}`}>
        {children}
      </main>
    </div>
  );
}
